<script lang="ts">
import { Component, Prop } from 'vue-property-decorator';
import { VBtn } from 'vuetify/lib';

@Component
export default class TextButton extends VBtn {
  @Prop({ default: 'primary' }) readonly color!: string;
  @Prop({ default: true }) readonly text!: boolean;
}
</script>
